import React from 'react';
import { Alert, Typography } from 'antd';
import styles from './StatusMessages.module.css';

export interface StatusMessage {
  // message text
  message: string
  // message status color
  status: 'info' | 'success' | 'warning' | 'error'
};

export interface StatusMessagesProps {
  items: StatusMessage[]
};

// displays given status messages
// with success, warning, info, or error status
const StatusMessages = (props: StatusMessagesProps): JSX.Element | null => {
  return props.items.length > 0
    ? <div className={styles.statusMessagesContainer}>
        {props.items.map((sm: StatusMessage, index: number) => (
          <Alert
            key={index}
            message={
              <Typography.Text
                className={styles.statusMessage}
              >
                {sm.message}
              </Typography.Text>}
            type={sm.status}
            showIcon={true}
          />
        ))}
      </div>
    : <></>
};

export default StatusMessages;
